import { httpsCallable } from 'firebase/functions';
import { functions } from './config';

export interface LiveKitTokenRequest {
  roomName: string;
  participantName: string;
  metadata?: string;
}

export interface LiveKitTokenResponse {
  token: string;
}

/**
 * Get a LiveKit access token for video calls
 * @param roomName - The name of the room to join (e.g., "coaching-{sessionId}")
 * @param participantName - The display name of the participant
 * @param metadata - Optional JSON metadata (role, appointmentId, etc.)
 * @returns Promise<string> - The JWT token for LiveKit
 */
export async function getLiveKitToken(
  roomName: string,
  participantName: string,
  metadata?: string
): Promise<string> {
  try {
    const getLivekitToken = httpsCallable<LiveKitTokenRequest, LiveKitTokenResponse>(
      functions,
      'getLivekitToken'
    );

    const result = await getLivekitToken({
      roomName,
      participantName,
      metadata,
    });

    console.log('[LiveKit] Token response received');
    
    const token = result.data.token;
    
    if (!token || typeof token !== 'string') {
      console.error('[LiveKit] Invalid token received:', token);
      throw new Error('Invalid token format received from server');
    }

    return token;
  } catch (error) {
    console.error('[LiveKit] Error getting token:', error);
    throw error;
  }
}
